import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './SendDeviceUnavailabilityAlertsField.module.scss';

export const SendDeviceUnavailabilityAlertsField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = restaurantForFullInfo?.sendDeviceUnavailabilityAlerts;
	const inputValue = t('sendDeviceUnavailabilityAlertsLabel');

	return (
		<FullInfoField
			containerClassName={style.containerClassName}
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
